export enum TimeIntervalPeriod {
	MONTHLY = 'MONTHLY',
	QUARTERLY = 'QUARTERLY',
	YEARLY = 'YEARLY',
}
